import React from 'react'
import { graphql } from 'gatsby'
import Section from '../components/Section'
import Layout from '../components/Layout'

const SectionPage = (props) => {
  if (!props.data) {
    return null
  }
  const { pageContext, data } = props
  const usedVehicles =
    data.allUsedVehicleCatfish &&
    data.allUsedVehicleCatfish.edges
      .map(({ node }) => node)
      .map((vehicle) => {
        const hpMonthlyPayment = vehicle.hpFinance.monthlyPayment
        const pcpMonthlyPayment = vehicle.pcpFinance.monthlyPayment
        let monthlyPayment = hpMonthlyPayment

        if (
          pcpMonthlyPayment &&
          (!hpMonthlyPayment || hpMonthlyPayment > pcpMonthlyPayment)
        ) {
          monthlyPayment = pcpMonthlyPayment
        }

        return {
          ...vehicle,
          monthlyPayment
        }
      })
  const latestArticles = data.allArticleCatfish
    ? data.allArticleCatfish.edges.map(({ node }) => node)
    : []
  const makes = data.allMakeCatfish
    ? data.allMakeCatfish.edges.map(({ node }) => node)
    : []
  const models = data.allModelCatfish
    ? data.allModelCatfish.edges.map(({ node }) => node)
    : []
  const locations = data.locations
    ? data.locations.edges.map(({ node }) => node)
    : []
  const bodyTypes = data.allBodyTypeCatfish
    ? data.allBodyTypeCatfish.edges.map(({ node }) => node)
    : []
  return (
    <Layout
      location={props.location}
      discoverable={pageContext.section.discoverable}
    >
      <Section
        {...pageContext.section}
        makes={makes}
        allModels={models}
        allBodyTypes={bodyTypes}
        usedVehicles={usedVehicles}
        latestArticles={latestArticles}
        locations={locations}
      />
    </Layout>
  )
}

export const pageQuery = graphql`
  fragment articleSummary on ArticleCatfish {
    id: _id
    headline
    shortHeadline
    slug
    displayDate
    images
    tags
  }

  fragment makeSummary on MakeCatfish {
    _id
    name
    shortName
    slug
    category
    order
    brandName
    state
  }

  fragment modelSummary on ModelCatfish {
    _id
    name
    thumbnailImages
    category
    parentModel
    slug
    make
    state
    bodyTypes
  }

  query SectionData {
    locations: allDealershipCatfish(sort: { shortName: ASC }) {
      edges {
        node {
          _id
          slug
          shortName
          addressLine1
          addressLine2
          addressLine3
          town
          county
          postcode
          slug
          images
          thumbnailImages
          vehicles {
            slug
          }
          complaintAreas {
            area
          }
        }
      }
    }
    allMakeCatfish(
      filter: { state: { eq: "Published" } }
      sort: { order: ASC }
    ) {
      totalCount
      edges {
        node {
          ...makeSummary
        }
      }
    }
    allModelCatfish(filter: { state: { eq: "Published" } }) {
      totalCount
      edges {
        node {
          ...modelSummary
        }
      }
    }
    allUsedVehicleCatfish(
      filter: { expiredDate: { eq: null }, state: { eq: "Published" } }
    ) {
      totalCount
      edges {
        ...usedVehicleSummaryWidgetFields
      }
    }
    allArticleCatfish(
      filter: { state: { eq: "Published" } }
      sort: { displayDate: DESC }
      limit: 5
    ) {
      edges {
        node {
          ...articleSummary
        }
      }
    }
    allBodyTypeCatfish {
      edges {
        node {
          id: _id
          name
        }
      }
    }
  }
`

export default SectionPage
